export const isThreeDSecureError = (error: string) => {
  return [
    'three_d_secure_action_required',
    '3d_secure_action_required',
  ].includes(error)
}
